/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Summary_Count_OneInputs */



/**
* | output |
* | --- |
* | "You have 1:1s with 1 colleague." |
*
* @param {Team_Summary_Count_OneInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const team_summary_count_one = /** @type {((inputs?: Team_Summary_Count_OneInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Summary_Count_OneInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Je hebt 1:1's met 1 collega.")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Vous avez des one-to-ones avec 1 collègue.")
	return /** @type {LocalizedString} */ ("You have 1:1s with 1 colleague.")
});